<!-- Generated by AI start - Cursor - 2025-08-22 -->
<template>
  <div class="pay-pending-page">
    <!-- 等待支付 -->
    <div class="pay-pending-content">
      <div class="pay-pending-title">
        <span>等待支付</span>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/index";
export default {
  name: "pay_pending",
  data() {
    return {
      returnUrl: ""
    };
  },
  mounted() {
  },
  methods: {

  }
};
</script>

<style scoped>
</style>
<!-- Generated by AI end -->
